import * as BusinessManagerApi from '@wix/business-manager-api';

export const getRestaurantAppState = async () => {
  if (await window['ModuleRegistry'].invoke('businessManager.isAppInstalled', BusinessManagerApi.appDefIds.restaurantsOrders)) {
    return { appState: 'ordersSettings' };
  } else {
    if (await window['ModuleRegistry'].invoke('businessManager.isAppInstalled', BusinessManagerApi.appDefIds.restaurantsSeating)) {
      return { appState: 'reservationsSettings' };
    }
  }
  return null;
};
